module.exports = __webpack_public_path__ + "img/icons.24851fa.svg";